import { Component, OnInit, Inject } from '@angular/core';
import { ClienteCampoPersonalizadoService } from 'src/app/services/cliente-campo-personalizado.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Segmentacao } from 'src/app/models/segmentacao';
import { PremissasService } from 'src/app/services/premissas.service';
import { SegmentacaoService } from 'src/app/services/segmentacao.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { PedidoCampoPersonalizadoService } from 'src/app/services/pedido-campo-personalizado.service';
import { PedidoCampoPersonalizadoSelecionadoService } from 'src/app/services/pedido-campo-personalizado-selecionado.service';
import { PremissasSistema } from 'src/app/models/premissas-sistema';

@Component({
  selector: 'app-gerenciar-classificacao-personalizada-modal',
  templateUrl: './gerenciar-classificacao-personalizada-modal.component.html',
  styleUrls: ['./gerenciar-classificacao-personalizada-modal.component.scss']
})
export class GerenciarClassificacaoPersonalizadaModalComponent implements OnInit {

  tabelas = [];
  editavel = false;
  mostrarClassificacao = false;
  classificacaoSelecionada;
  classificacao: Segmentacao[];
  classificacaoTexto: string = 'Sem classificação';
  fidelidadeGoSolar = false;
  mostrarSalvar: boolean = false;
  idCupom: string = "";
  telaClassificacao: boolean = false;
  premissasSistema = new PremissasSistema();


  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<GerenciarClassificacaoPersonalizadaModalComponent>,
    private clienteCampoPersonalizadoService: ClienteCampoPersonalizadoService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private premissasService: PremissasService,
    private segmentacaoService: SegmentacaoService,
    private pedidoCampoPersonalizadoSelecionadoService: PedidoCampoPersonalizadoSelecionadoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (this.data !== null && this.data !== undefined) {
      this.tabelas = this.data.tabelas;
      this.editavel = this.data.editavel;
      this.mostrarClassificacao = this.data.mostrarClassificacao;
      this.classificacaoSelecionada = this.data.classificacaoSelecionada;
      this.mostrarSalvar = this.data.mostraSalvar;
      this.idCupom = this.data.idCupom;
      this.telaClassificacao = this.data.telaClassificacao;
    }
  }

  ngOnInit(): void {
    this.buscarPremissasSistema();

    if (this.mostrarClassificacao) {
      this.buscarClassificacao();
    }
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');

    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;
        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  fechar() {

    if (!this.mostrarClassificacao) {
      if (!this.telaClassificacao)
        this.dialogRef.close(this.tabelas);
      else
        this.dialogRef.close(false);
    }
    else {
      this.dialogRef.close();
    }
  }

  salvar() {
    if (this.mostrarClassificacao) {
      this.dialogRef.close({ tabelas: this.tabelas, classificacaoSelecionada: this.classificacaoSelecionada });
    } else if (this.mostrarSalvar) {

      this.carregandoService.mostra('salvaFilterPerson');
      this.pedidoCampoPersonalizadoSelecionadoService.salvar(this.tabelas, this.idCupom).subscribe(resp => {
        this.carregandoService.esconde('salvaFilterPerson');
        this.notificacaoService.sucesso('Campos Personalizados Salvo');

        this.dialogRef.close(true);
      }, (erro) => {
        this.notificacaoService.erro('Erro ao salvar filtro');
        console.error(erro);
        this.carregandoService.esconde('salvaFilterPerson');
      });

    }
  }

  buscarClassificacao() {
    this.carregandoService.mostra('buscarClassificacao');

    this.segmentacaoService.consultar().subscribe(dados => {
      this.classificacao = dados;

      if (this.premissasSistema.vinculoClassificacaoPorApi && this.classificacaoSelecionada !== null && this.classificacaoSelecionada !== undefined) {
        this.classificacaoTexto = this.classificacao.find(c => c.id === this.classificacaoSelecionada).descricao;
      }

      this.carregandoService.esconde('buscarClassificacao');
    }, (erro) => {
      this.carregandoService.esconde('buscarClassificacao');
      this.notificacaoService.erro(erro);
    });
  }
}
